import { h } from "preact";
function DeliveryAddressDivider() {
    return h("div", { class: "m-delivery-address__br" });
}
export default DeliveryAddressDivider;
